import * as z from 'zod';
/**
 * What came of sending the addons email to a booking's guest, from POST bookings/send-addons-email.
 * Anything but `sent` says why nothing was sent; the server's snackbar tells staff.
 */
export const SendBookingAddonsEmailResult = z.object({
    outcome: z.enum(['sent', 'no_email_address', 'email_blocked', 'nothing_to_offer', 'no_addons_link'])
});
